module.exports = __webpack_public_path__ + "img/cast_ic_networking.07e2e0a5.svg";